/**
 *
 * key
 *
 */

 const key = 'YmRtU291cmNlU3RhdHVz'

 export default key
 